import { FunctionComponent } from 'react'

// Stroke icons from leaddelta.com/pricing, kept local because the shared SvgFragment/Button styles fill `.path`.
const ICONS = {
    check: <path d="M13.3333 4L6 11.3333L2.66667 8" strokeWidth="1.5" />,
    arrowRight: <path d="M3.33333 8H12.6667M8 3.33333L12.6667 8L8 12.6667" strokeWidth="1.33333" />,
    crown: <>
        <path d="M7.708 2.17733C7.73678 2.12507 7.77905 2.08149 7.83041 2.05114C7.88177 2.02078 7.94034 2.00477 8 2.00477C8.05966 2.00477 8.11823 2.02078 8.16959 2.05114C8.22095 2.08149 8.26323 2.12507 8.292 2.17733L10.26 5.91333C10.3069 5.99984 10.3724 6.07489 10.4518 6.13308C10.5312 6.19127 10.6224 6.23117 10.7191 6.24991C10.8157 6.26864 10.9153 6.26576 11.0106 6.24145C11.106 6.21715 11.1948 6.17203 11.2707 6.10933L14.122 3.66667C14.1767 3.62215 14.2442 3.59614 14.3146 3.5924C14.3851 3.58866 14.4549 3.60736 14.5141 3.64583C14.5732 3.6843 14.6186 3.74054 14.6438 3.80646C14.6689 3.87238 14.6725 3.94458 14.654 4.01267L12.7647 10.8433C12.7261 10.9831 12.643 11.1065 12.528 11.1948C12.413 11.2831 12.2723 11.3315 12.1273 11.3327H3.87333C3.72822 11.3317 3.58741 11.2833 3.47226 11.195C3.35712 11.1067 3.27393 10.9832 3.23533 10.8433L1.34667 4.01333C1.32817 3.94525 1.33175 3.87305 1.35689 3.80713C1.38204 3.74121 1.42745 3.68496 1.4866 3.6465C1.54575 3.60803 1.61557 3.58932 1.68603 3.59307C1.75648 3.59681 1.82393 3.62281 1.87867 3.66733L4.72933 6.11C4.8052 6.17269 4.89401 6.21781 4.98938 6.24212C5.08475 6.26642 5.18431 6.26931 5.28093 6.25057C5.37755 6.23184 5.46882 6.19194 5.54819 6.13375C5.62757 6.07555 5.69307 6.00051 5.74 5.914L7.708 2.17733Z" strokeWidth="1.33333" />
        <path d="M3.33333 14H12.6667" strokeWidth="1.33333" />
    </>,
    rocket: <>
        <path d="M5.5 10.5c-1.5.4-2.3 1.7-2.5 3.5 1.8-.2 3.1-1 3.5-2.5" />
        <path d="M9 11.5 6.5 9 4.5 7C7 2.5 10.5 2 13.5 2.5c.5 3 0 6.5-4.5 9Z" />
        <path d="M9.5 6.5a1 1 0 1 0 1.5 1.3" />
    </>,
    users: <>
        <circle cx="6" cy="5.5" r="2.3" />
        <path d="M2.3 13.5a3.7 3.7 0 0 1 7.4 0" />
        <path d="M10.8 3.5a2.3 2.3 0 0 1 0 4.3M11.2 9.8a3.7 3.7 0 0 1 2.5 3.2" />
    </>,
    sparkles: <>
        <path d="M8 2.5 9.2 6.3 13 7.5 9.2 8.7 8 12.5 6.8 8.7 3 7.5 6.8 6.3 8 2.5Z" />
        <path d="M13 2.5v2M12 3.5h2" />
    </>,
    layers: <>
        <path d="M8 2.5 14 5.5 8 8.5 2 5.5 8 2.5Z" />
        <path d="M2.5 8.5 8 11.2 13.5 8.5M2.5 11 8 13.7 13.5 11" />
    </>,
    shield: <path d="M8 2 13 4v4c0 3.2-2.1 5.2-5 6-2.9-.8-5-2.8-5-6V4l5-2Z" />,
    settings: <g transform="scale(0.6667)" strokeWidth="1.7">
        <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2Z" />
        <circle cx="12" cy="12" r="3" />
    </g>
}

export type TPricingIcon = keyof typeof ICONS

interface IPricingIconProps {
    type: TPricingIcon
    className?: string
}

const PricingIcon: FunctionComponent<IPricingIconProps> = ({ type, className }) => (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {ICONS[type]}
    </svg>
)

export default PricingIcon
